import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { t } from "@/i18n-js/instance";

interface ConversationFullscreenToggleButtonProps {
  "aria-controls"?: string;
  "data-testid"?: string;
  isFullscreen: boolean;
  onToggle: () => void;
}

export const ConversationFullscreenToggleButton = ({
  "aria-controls": ariaControls,
  "data-testid": testId,
  isFullscreen,
  onToggle,
}: ConversationFullscreenToggleButtonProps) => {
  const label = isFullscreen
    ? t("ai_conversation.header.exit_fullscreen")
    : t("ai_conversation.header.enter_fullscreen");

  return (
    <Tooltip content={label} side="bottom">
      <IconButton
        data-testid={testId}
        onClick={onToggle}
        icon={isFullscreen ? "minimize" : "expand"}
        size="sm"
        variant="ghost"
        aria-label={label}
        aria-pressed={isFullscreen}
        aria-controls={ariaControls}
      />
    </Tooltip>
  );
};
